export default "__VITE_ASSET__335db51b__"